<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-01 14:50:38
 * @LastEditTime: 2019-08-16 15:51:37
 * @LastEditors: Please set LastEditors
 -->
<template>
    <!-- 经销商库存统计 -->
    <div>
          <div class="pageTitle secondTitle">经销商库存统计(统计数据非实时统计,更新截止前一天)</div>
         <el-tabs v-model="activeName" type="card"  @tab-click="handleClick">
            <el-tab-pane label="经销商库存统计(经销商)" name="1">
                 <el-form ref="form" :model="form" label-width="120px" :inline="true">
                    <dealerLeve @leves='getLeve'  >
                    </dealerLeve>
                    <el-form-item  label="生产批次号:">
                        <el-input v-model="form.production_batch" clearable ></el-input>
                    </el-form-item>
                      <el-form-item  label="产品编号:">
                        <el-input v-model="form.product_sn" clearable ></el-input>
                    </el-form-item>
                     <el-form-item  label="产品名称:">
                        <el-input v-model="form.product_name" clearable ></el-input>
                    </el-form-item>
                  
                        <el-form-item label="经销商:">
                <el-col :span="12">
                    <el-input v-model="form.to_sn" clearable></el-input>
                </el-col>
                <el-col :span="4" style="margin-left: 10px;">
                    <el-button type="primary" @click="selectDealerDialog=!selectDealerDialog">选择</el-button>
                </el-col>
            </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="onSearch()">搜索</el-button>
                        <el-button type="primary" @click="exportData()">导出</el-button>

                    </el-form-item>
                </el-form>

                <div>总库存数: <span style='color:#f04635'>{{total}}</span>   </div>
                   <el-table
                ref="multipleTable"
                :data="tableData"
                v-loading="loading"
                height="300"
                border
                stripe
                 style="margin: 20px 0;width:95%">
            <el-table-column
                    prop="dealer_sn"
                    label="序号"
                    width="100"
                    fixed>
                    <template slot-scope="scope">
                        {{scope.$index}}
                    </template>
            </el-table-column>
            <el-table-column
                    prop="to_name"
                    label="经销商名称"
                   
                    show-overflow-tooltip>
            </el-table-column>

            <el-table-column
                    prop="to_level_name"
                    label="经销商级别"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="to_sn"
                    label="经销商编号"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="residue_num"
                    label="剩余数量"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop=""
                    label="操作"
                    show-overflow-tooltip>
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="detail(scope.row)">明细</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!--分页-->
        <el-pagination
                style="margin: 20px 0"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageNo"
                :page-sizes="[20, 50, 100, 200]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalSize">
        </el-pagination>
            </el-tab-pane>
            <el-tab-pane label="经销商库存统计(产品)" name="2">

                     <el-form ref="form1" :model="form1" label-width="120px" :inline="true">
              
                    
                    <dealerLeve @leves='getLeve'  >
                    </dealerLeve>
                    <el-form-item  label="生产批次号:">
                        <el-input v-model="form1.production_batch" clearable ></el-input>
                    </el-form-item>
                      <el-form-item  label="产品编号:">
                        <el-input v-model="form1.product_sn" clearable ></el-input>
                    </el-form-item>
                     <el-form-item  label="产品名称:">
                        <el-input v-model="form1.product_name" clearable ></el-input>
                    </el-form-item>
               
                <el-form-item label="经销商:">
                <el-col :span="12">
                    <el-input v-model="form1.to_sn" clearable></el-input>
                </el-col>
                <el-col :span="4" style="margin-left: 10px;">
                    <el-button type="primary" @click="selectDealerDialog=!selectDealerDialog">选择</el-button>
                </el-col>
            </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="onSearch()">搜索</el-button>
                        <el-button type="primary" @click="exportData()">导出</el-button>

                    </el-form-item>
                </el-form>
    <br/>
                   <el-table
                ref="multipleTable"
                :data="tableData1"
                v-loading="loading"
                height="300"
                border
                stripe
                  style="width:95%">
            <el-table-column
                    prop=""
                    label="序号"
                    width="100"
                    fixed>
                    <template slot-scope="scope">
                        {{scope.$index}}
                    </template>
            </el-table-column>
            <el-table-column
                    prop="product_sn"
                    label="产品编号"
                      fixed>
            </el-table-column>
            <el-table-column
                    prop="product_name"
                    label="产品名称"
                   >
            </el-table-column>
            <el-table-column
                    prop="product_specs"
                    label="规格"
                 >
            </el-table-column>
            <el-table-column
                    prop="inwarehouse_num"
                    label="入库数量"
                    >
            </el-table-column>
              <el-table-column
                    prop="outwarehouse_num"
                    label="出货数量"
                  >
            </el-table-column>
              <el-table-column
                    prop="returngoods_num"
                    label="退货数量"
                >
            </el-table-column>
              <el-table-column
                    prop="stock_total"
                    label="剩余数量"
             >
            </el-table-column>
            <el-table-column
                    prop=""
                    label="操作"
                    width="180"
                    show-overflow-tooltip>
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="detail(scope.row)">明细</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!--分页-->
        <el-pagination
                style="margin: 20px 0"
                @size-change="handleSizeChange1"
                @current-change="handleCurrentChange1"
                :current-page="pageNo1"
                :page-sizes="[20, 50, 100, 200]"
                :page-size="pageSize1"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalSize1">
        </el-pagination>
            </el-tab-pane>
      
        </el-tabs>
                  <!--选择经销商-->
        <selectDealer
                v-if="selectDealerDialog"
                v-on:handleClose='selectDealerDialog = false'
                @pushData="getSelectinfo">
        </selectDealer>
             <el-dialog
      title="明细"
      :visible.sync="DetailDialog"
      width="80%"
      >
        <el-button type="primary" @click="exproDetail" style='margin-bottom:10px'>导出</el-button>
      <el-table
              ref="multipleTable"
              :data="tableData3"
              v-loading="loading"
              border
              stripe
            >
                <el-table-column prop='production_batch'  label="生产批次号" fixed v-if='isCodeShow' >
              </el-table-column>
              <el-table-column prop='to_sn' label="经销商编号" fixed v-if='activeName==2'>
              </el-table-column>
              <el-table-column prop='to_name' label="经销商名称"  v-if='activeName==2'>
              </el-table-column>
              <el-table-column prop='to_level_name' label="经销商级别" v-if='activeName==2' >
              </el-table-column>
                    <el-table-column prop='product_sn' label="产品编号" fixed v-if='activeName==1'>
              </el-table-column>
              <el-table-column prop='product_name' label="产品名称"  v-if='activeName==1'>
              </el-table-column>
              <el-table-column prop='product_specs' label="产品规格" v-if='activeName==1' >
              </el-table-column>
              <el-table-column prop='inwarehouse_num' label="入库数量"  >
              </el-table-column>
              <el-table-column prop='outwarehouse_num' label="发货数量"  >
              </el-table-column>
               <el-table-column prop='returngoods_num' label="退货数量"  >
              </el-table-column>
               <el-table-column prop='retail_num' label="零售数量"  >
              </el-table-column>
               <el-table-column prop='stock_total' label="库存数量"  >
              </el-table-column>
               <el-table-column prop='production_date' label="生产日期"  fixed="right"  v-if='isCodeShow' >
              </el-table-column>
               <el-table-column prop='expiring_date' label="有效期至"  fixed="right" v-if='isCodeShow'>
              </el-table-column>
            </el-table>
                    <el-pagination
              style="margin: 20px 0"
              @size-change="handleSizeChange3"
              @current-change="handleCurrentChange3"
              :current-page="pageNo3"
              :page-sizes="[10, 15, 20, 25]"
              :page-size="pageSize3"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalSize3"
            ></el-pagination>
      <span slot="footer" class="dialog-footer">
        <el-button @click="DetailDialog = false,pageSize3=10,pageNo3=1">取 消</el-button>
        <el-button type="primary" @click="DetailDialog = false,pageSize3=10,pageNo3=1">确 定</el-button>
      </span>
    </el-dialog>
    </div>
</template>


<script>
 import selectDealer from '../../../common/selectDealer';
 import dealerLeve from '../../../common/dealerLeve'
export default {
    name:'stock',
    data(){
        return{
            selectDealerDialog:false,
            DetailDialog:false,
            activeName:'1',
             form1:{
                to_sn:"",
                to_level_id:""
              , product_name:""
              ,product_sn:""
             ,production_batch:""
             },
             form:{
                     to_level_id:"",
               to_sn:"",
                product_name:"",
                product_sn:"",
                 production_batch:""
             },
              pageNo: 1,
              pageSize: 10,
              totalSize: 0,
               pageNo1: 1,
              pageSize1: 10,
              totalSize1: 0,
                 pageNo3: 1,
              pageSize3: 10,
              totalSize3: 0,
              total:0,
              tableData:[],
              tableData1:[],
              tableData3:[],
              detailData:{},
              isCodeShow:true
        }
    },
    methods:{
            onSearch(){
            this.loading=true
            if(this.activeName==1){
                this.$get('logistics','/dealers.stocks.total',{
                    per_page:this.pageSize,
                    page:this.pageNo,
                    ...this.form
                }).then(res=>{
                    this.tableData=res.data
                    this.loading=false
                        this.totalSize=res.meta.total
                        this.total=res.real_stock_out_num

                })
            }else{
        this.$get('logistics','/dealers.stocks.products',{
                    per_page:this.pageSize1,
                    page:this.pageNo1,
                    ...this.form1
                }).then(res=>{
                    this.tableData1=res.data
                    this.loading=false
                        this.total=res.real_stock_out_num
                        this.totalSize1=res.meta.total

                })
            }
        },
            // 获取经销商等级
        getLeve(value){
            if(this.activeName==1){
                this.form.to_level_id=value
            }else{
                this.form1.to_level_id=value
            }
        },
              // 获取经销商 编号
        getSelectinfo(value){
             if(this.activeName==1){
                this.form.to_sn=value.dealer_sn
            }else{
                this.form1.to_sn=value.dealer_sn
            }
        },
              // 导出
        exportData(){
             let url = "",
        access_tokens = localStorage.getItem("access_tokens");
 
        if(this.activeName==1){
            window.open(
                   this.$Base_Export+
                    "/dealers.stocks.total.export?"+   
                    '&to_level_id='+this.form.to_level_id+
                    '&to_sn='+this.form.to_sn+
                    '&product_name='+this.form.product_name+
                    '&product_sn='+this.form.product_sn+
                    '&production_batch='+this.form.production_batch+
                    "&lang=" +''+
                    '&is_export=1'+
                    "&signature=" +
                    this.$md5(access_tokens)
                );
                }else{
        window.open(
                url +
                process.env.VUE_APP_URL +
                "/dealers.stocks.products.export?"+   
                '&to_sn='+this.form1.to_sn+
                '&to_level_id='+this.form1.to_level_id+
                        '&product_name='+this.form1.product_name+
                    '&product_sn='+this.form1.product_sn+
                    '&production_batch='+this.form1.production_batch+
                "&lang=" +''+
                '&is_export=1'+
                "&signature=" +
                this.$md5(access_tokens)
            );
            }
        },
           // 查看详情
        detail(data){
             this.tableData3=[]
            this.loading=true
            this.DetailDialog=true
               console.log(data)

            if(data){
                this.detailData=data
            }
           if(this.activeName==1){
                this.$get('logistics','/dealers.stocks.total/datas',{
                    to_sn :this.detailData.to_sn ,
                    per_page:this.pageSize3,
                    page:this.pageNo3,
                }).then(res=>{
                     this.loading=false
                    this.tableData3=res.data
                     this.totalSize3=res.meta.total
                })
            }else{
                  this.$get('logistics','/dealers.stocks.products/datas',{
                    product_sn:this.detailData.product_sn  ,
                    per_page:this.pageSize3,
                    page:this.pageNo3,
                }).then(res=>{
            this.loading=false

                        this.totalSize3=res.meta.total
                    this.tableData3=res.data
                })
            }
        },
            // 导出详情
        exproDetail(){
          let url = "",
                        access_tokens = localStorage.getItem("access_tokens");
                 
            if(this.activeName==1){
                window.open(
                this.$Base_Export +
                "/dealers.stocks.total/datas.export?to_sn="+this.detailData.to_sn+   
                "&lang=" +''+
                '&is_export=1'+
                "&signature=" +
                this.$md5(access_tokens)
            );
            }else{
     window.open(
                this.$Base_Export +
                "/dealers.stocks.products/datas.export?product_sn="+this.detailData.product_sn +
                "&lang=" +''+
                '&is_export=1'+
                "&signature=" +
                this.$md5(access_tokens)
            );
            }
        },
            handleSizeChange(val){
            this.pageSize=val
            this.onSearch()
        },
        handleCurrentChange(val){
            this.pageNo=val

            this.onSearch()

        },
           handleSizeChange1(val){
            this.pageSize1=val
            this.onSearch()
        },
        handleCurrentChange1(val){
            this.pageNo1=val

            this.onSearch()
        },
                handleSizeChange3(val){
            this.pageSize3=val
            this.detail()
        },
        handleCurrentChange3(val){
            this.pageNo3=val

            this.detail()
        },
        handleClick(){
            this.onSearch()
        },
              //获取基础配置
            getConfigInfo(){
                this.$get('logistics', '/configs', {
                    lang: ''
                }).then(res => {
                    console.log(res);
                    if(res.data.production_batch_on_off == 0){
                        this.isCodeShow = false;

                    }else if(res.data.production_batch_on_off == 1){
                        this.isCodeShow = true;
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
    },
    created(){
        this.onSearch()
        this.getConfigInfo()
    },
    components:{
        selectDealer,
        dealerLeve
    }
}
</script>
